export default "__VITE_ASSET__l2ozCLq7__"